import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/solid'

interface Props {
    disablePrev?: boolean
    disableNext?: boolean
    hidePrev?: boolean
    hideNext?: boolean
    onPrev?: () => void
    onNext?: () => void
}

const ModalNavigation = ({ hidePrev, hideNext, disablePrev, disableNext, onPrev, onNext }: Props) => {
  return (
    <div className='flex items-center gap-2'>
        {!hidePrev && (
            <div className={`flex items-center justify-center bg-[#9d62fe] p-2 rounded-lg cursor-pointer ${disablePrev ? "opacity-50 pointer-events-none cursor-not-allowed" : ""}`} onClick={onPrev}>
                <ChevronLeftIcon
                    className={`w-[30px] h-[30px] text-white`}
                />
            </div>
        )}
        {!hideNext && (
            <div className={`flex items-center justify-center bg-[#9d62fe] p-2 rounded-lg cursor-pointer ${disableNext ? "opacity-50 pointer-events-none cursor-not-allowed" : ""}`} onClick={onNext}>
                <ChevronRightIcon
                    className={`w-[30px] h-[30px] text-white`}
                />
            </div>
        )}
    </div>
  )
}

export default ModalNavigation